import {createSinglePathSVG} from './TEMPLATE'

export const AlignLeft_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M13.3333 8.33333H2.5M16.6667 5H2.5M16.6667 11.6667H2.5M13.3333 15H2.5',
})
